import layoutActions from "actions/layout";
import mapActions from "actions/map";
import modalActions from "actions/modal";
import { connect, generatedActions, viewStateToProps } from "helpers/redux";

const customDispatch = (dispatch) => {
    return {
        mergeParams: (params) => dispatch(generatedActions.distributionbids.merge(params)),
        clearData: () => dispatch(layoutActions.clearData()),
        modal: (params) => dispatch(modalActions.open(params)),
        switchMap: (params) => dispatch(mapActions.switchMap(params)),
    };
};

const customConnect = (Component) => connect(viewStateToProps, customDispatch)(Component);

export { customConnect };
